import React from "react";

const Finish = () => <div className="finish"></div>;

export default Finish;
